<template>
  <div class="handling-manage-reason">
    <FaulTreeSelected
      class="select-fault-tree"
      :reset="this.resetModel"
      @sendTreeData="receive = $event"
      @indicators="indicators=$event"
    ></FaulTreeSelected>

    <div :class="{'fault-decision-tree': user.role == 'PGDI', 'fault-decision-tree-gdi': user.role == 'GDI', 'mt-2': true}">
      <div class="fault">
        <faultTree
          v-if="!reloadTree"
          class="fault-tree"
          :editable="true"
          :data="treeData"
          :refresh="sendBkp"
          :getTree="getTree"
          @updateTree="updateTree($event)"
          @nodeDbClick="setPath($event)"
        ></faultTree>
        <span v-else>
          <p class="mt-3">{{ $t('carregando-arvore-de-falhas') }}</p>
        </span>
      </div>
      <div class="decision" v-if="user.role == 'PGDI'">
        <span v-if="!reloadDecisionTree">
          <div class="selected-decision">
            <label class="decision-tree-label">{{nodeSelected.node.data.text}} </label>
            <hr class="hr-decision-tree">
          </div>
          <decisionTree
            class="decision-tree"
            :editable="true"
            :data="decisionTreeData"
            :refresh="sendBkp"
            :getTree="getTree"
            @updateTree="updateDecisionTree($event)"
          ></decisionTree>
        </span>
        <span v-else>
          <p class="mt-2">{{ $t('selecione-um-motivo') }}</p>
        </span>
      </div>
    </div>
    <div class="group-buttons-tree">
      <hr class="hr-group-buttons-tree" />
      <b-row class="groupBtn">
        <label for="importCSV" v-if="!waitingImportExcel">
          <img
              class="importar-excel mr-4"
              src="@/assets/importar.png"
              alt="Importar cenário"
            />
          <input id="importCSV" type="file" hidden="true" ref="myExcel" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="selectedFile">
        </label>
        <span
          v-else
          class="collor-spinner spinner-border spinner-border-sm mr-4"
          role="status"
          aria-hidden="true"
        ></span>
        <div>
          <b-icon v-b-modal.CopyTreeToIndicator
            class="copy"
            :title="$t('copiar-arvore')"
            icon="files"
          >
          </b-icon>

        </div>
        <div>
          <img
            src="@/assets/salvar.png"
            alt="salvar"
            style="margin-left: 30px"
            :title="$t('salvar')"
            @click="
              () => {
                getTree++;
              }
            "
          />
          <img
            src="@/assets/atualizar.png"
            style="margin-left: 30px"
            :title="$t('limpar')"
            alt="limpar"
            @click="resetForm"
          />
          <img
            id="closeModalPassword"
            class="float-right"
            src="@/assets/sair.png"
            style="margin-left: 30px"
            :title="$t('sair')"
            alt="Sair"
            @click="$bvModal.hide('faulttreeManagement')"
          />
        </div>
      </b-row>
    </div>

    <b-modal
      :title="$t('copiar-dados-de') + `[${indicatorSelected}]`"
      id="CopyTreeToIndicator"
      hide-footer
      centered 
      size="lg">

      <CopyTreeToIndicatorVue
        :indicators="indicatorsToCopy"
        @copy="copyToIndicators($event)"
      />
    </b-modal>
  </div>
</template>

<script>
import FaultTree from "./template/FaultTree.vue";
import DecisionTree from "./template/DecisionTree.vue";
import FaulTreeSelected from "./template/FaultTreeSelected.vue";
import { faultTreeMixin } from "../mixins/faultTreeMixin";
import { urlMainAPI, defaultSuccess, showError } from "@/global";
import CopyTreeToIndicatorVue from "./template/CopyTreeToIndicator.vue";
import SetIdInTree from "./utils/SetIdInTree";
import axios from "axios";
import { mapState } from 'vuex';

export default {
  name: "ManageOccurrenceHandling",

  mixins: [faultTreeMixin],

  components: { FaulTreeSelected, FaultTree, DecisionTree, CopyTreeToIndicatorVue },
  computed: mapState(["user"]),
  data() {
    return {
      reloadTree: true,
      reloadDecisionTree: true,
      sendBkp: null,
      sendDecisionBkp: null,
      loaded: false,
      treeData: [],
      decisionTreeData: [],
      receive: 0,
      copy: null,
      singleSelection: null,
      resetModel: 0,
      indicators: [],
      indicatorsToCopy: [],
      indicatorSelected: "",
      waitingImportExcel: false
    };
  },

  watch: {
    receive(value) {
      this.singleSelection = value;
      this.setConfigToCopy(value)
      this.changeTree(value);
      this.reloadDecisionTree = true;
    },
  },

  methods: {
    updateTree(data) {
      this.save(data);
    },

    updateDecisionTree(data) {
        this.saveDecision(data);
    },

    async selectedFile() {
      let file = this.$refs.myExcel.files[0];
      let type = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if(!file || file.type != type){
        showError("Arquivo inválido de excel");
        this.$refs.myExcel.value = "";
        return;
      }
      this.waitingImportExcel = true

      let fileExcel = new FormData();
      fileExcel.append("file", file)
      await axios.post(`${urlMainAPI}/importExcelToFaultTree`, fileExcel, { headers: {'Content-Type': 'multipart/form-data'} }).then(res => {
        if(res.status == 200){
          defaultSuccess(res.data)
        }
      }).catch(console.error)
      this.waitingImportExcel = false
    },

    setConfigToCopy(value){
      this.indicatorsToCopy = this.indicators.filter(i => i.value != value).map(i => ({indicador: i.text, value: i.value}))
      let indicatorFound = this.indicators.filter(i => i.value == value)
      if(indicatorFound.length > 0){
        this.indicatorSelected = indicatorFound[0].text
      }
    },

    copyToIndicators(copy){
      this.copping = true;
      this.indicatorsToCopy.toCopy = copy;
      let keyIndicator = `${this.singleSelection.id}-${this.singleSelection.productionUnitId}-${this.singleSelection.system}`
      let dictionaryToSend = {}
      let value = copy.map(c => `${c.value.id}-${c.value.productionUnitId}-${c.value.system}`)
      dictionaryToSend[keyIndicator] = value;

      axios.post(`${urlMainAPI}/copyfaulttreeanddecisiontree`, dictionaryToSend).then( res => {
        if(res.status == 200){
          defaultSuccess(res.data);
        }
      }).catch(console.error)
    },

    setPath(obj) {
      this.nodeSelected = obj;

      if (obj.nodes.children) this.otherDisabled = false;
      else this.otherDisabled = true;

      this.path = obj.path;

      this.changeDecisionTree(this.nodeSelected.node);
    },

    async save(data) {
      if (this.selected && this.selected.length == 0 && !this.singleSelection) {
        showError(this.$t('selecione-ao-menos-um-indicador-0'));
        return;
      }

      let faultTree = {};
      let tree = SetIdInTree.Set(data);

      if (this.selected && this.selected.length > 0) {
        this.selected.forEach(async (item) => {
          faultTree = {
            indicatorid: item.id,
            productionUnitId: item.productionUnitId,
            system: item.system,
            tree: JSON.stringify(tree),
          };
          await this.sendSave(faultTree);
        });
      } else if (this.singleSelection) {
        faultTree = {
          indicatorid: this.singleSelection.id,
          productionUnitId: this.singleSelection.productionUnitId,
          system: this.singleSelection.system,
          tree: JSON.stringify(tree),
        };
        await this.sendSave(faultTree);
      }
      this.resetModels();
      this.treeData = faultTree.tree;
      this.treeDataBkp = faultTree.tree;
    },

    async saveDecision(data) {
      defaultSuccess(this.$t('salvando-arvore-de-acoes'));
      let decisionTree = {};

      if (this.decisionTreeData) {
        decisionTree = {
          indicatorid: this.singleSelection.id,
          productionUnitId: this.singleSelection.productionUnitId,
          system: this.singleSelection.system,
          faultTreeId: this.nodeSelected.node.id,
          tree: JSON.stringify(data),
        };
        await this.sendSaveDecision(decisionTree);
      }
      this.resetModels();
      this.decisionTreeData = decisionTree.tree;
      this.treeDecisionDataBkp = decisionTree.tree;
    },

    resetModels() {
      this.copy = true;
      this.resetModel++;
    },

    async sendSave(faultTree) {
      await axios
        .post(`${urlMainAPI}/savefaulttree`, faultTree)
        .then((res) => {
          defaultSuccess(res.data);
        })
        .catch((err) => {
          console.log("err :>> ", err);
          showError(err);
        });
    },

    async sendSaveDecision(decisionTree) {
      await axios
        .post(`${urlMainAPI}/savedecisiontree`, decisionTree)
        .catch((err) => {
          console.log("err :>> ", err);
          showError(err);
        });
    },

    resetForm() {
      this.sendBkp++;
      this.sendDecisionBkp++;
      this.reloadTree = true;
      this.reloadDecisionTree = true;

      setTimeout(() => {
        this.treeData = {};
        this.treeData = this.treeDataBkp;
        this.decisionTreeData = {};
        this.decisionTreeData = this.treeDecisionDataBkp;
        this.reloadTree = false;
        this.reloadDecisionTree = true;
        defaultSuccess(this.$t('arvore-restaurada-ao-ultimo-ponto-salvo'));
      }, 500);
    },

    loadFaultTree() {
      axios
        .get(`${urlMainAPI}/getfaulttreeconfiguration`)
        .then((res) => {
          if (res.data) {
            this.indicators = this.formatIndicator(res.data.indicatorList);
            this.loaded = true;
          }
        })
        .catch(console.log);
    },

    async changeTree(data) {
      this.reloadTree = true;
      this.treeData = null;
      this.treeDataBkp = null;

      await axios
        .get(`${urlMainAPI}/getfaulttree/${data.id}/${data.productionUnitId}/${data.system}`)
        .then((res) => {
          if (res.data) {
            this.treeData = this.copyFrom(res.data);
            this.treeDataBkp = this.treeData;
            this.reloadTree = false;
          }
        })
        .catch(console.log);
    },

    async changeDecisionTree(data) {
      this.reloadDecisionTree = true;
      this.decisionTreeData = null;
      this.decisionTreeDataBkp = null;
      await axios
        .get(
          `${urlMainAPI}/getdecisiontree/${this.singleSelection.id}/${this.singleSelection.productionUnitId}/${this.singleSelection.system}/${data.id}`
        )
        .then((res) => {
          if (res.data) {
            this.decisionTreeData = this.copyFrom(res.data);
            this.decisionTreeDataBkp = this.decisionTreeData;
            this.reloadDecisionTree = false;
          }
        })
        .catch(console.log);
    },
  },

  created() {
    this.loadFaultTree();
  },
};
</script>

<style scoped>
.handling-manage-reason {
  display: grid;
  grid-template-rows: 7.5vh 64vh 7vh;
}

.fault-decision-tree-gdi,
.fault-decision-tree {
  display: grid;
  grid-template-columns: 50% 50%;
}

.fault-decision-tree-gdi{
  grid-template-columns: 100%;
}

.selected-decision {
  margin-top: 0px;
}

.fault,
.decision {
  box-shadow: 0 0 4px #0008;
  border-radius: 4px;
  padding: 4px;
  height: inherit;
  overflow-y: auto; 
  overflow: hidden;
}

.fault {
  overflow-y: auto;
  margin: 0 4px 0 0;
}

.groupBtn {
  margin-right: 0px;
}

.fault-tree {
  height: 100%;
  overflow-y: auto;
}

.decision-tree {
  height: calc(100% - 17px);
  overflow-y: auto;
}

.decision-tree-label {
  margin-top: 6px;
  font-weight: 600;
}

.hr-decision-tree {
  margin: 0px;
}

.hr-group-buttons-tree {
  margin-top: 10px;
}

.copy {
  height: 35px;
  width: 35px;
  color: #ff7100;
  transition-delay: 600ms;
  cursor: pointer;
}

.collor-spinner{
  height: 30px;
  width: 30px;
  color: #ff7100;
}

@media screen and (max-width: 1600px) and (max-height: 768px){
  .handling-manage-reason {
    display: grid;
    grid-template-rows: 8.5vh 63vh 7vh;
  }
}

@media screen and (max-width: 991px) {
  .handling-manage-reason {
    display: grid;
    grid-template-rows: 7vh 65vh 7vh;
  }

  .fault-decision-tree {
    display: grid;
    grid-template-rows: 50% 50%;
    grid-template-columns: none;
  }

  .fault {
    margin: 5px 4px 0 0;
  }

  .decision {
    margin: 10px 4px 0 0;
  }
}

@media screen and (max-width: 991px) and (max-height: 844px) {
  .handling-manage-reason {
    display: grid;
    grid-template-rows: 9.4vh 65vh 9.4vh;
  }

  .fault-decision-tree {
    display: grid;
    grid-template-rows: 50% 50%;
    grid-template-columns: none;
  }

  .fault {
    margin: 5px 4px 0 0;
  }

  .decision {
    margin: 10px 4px 0 0;
  }
}
</style>